import { createContext } from 'react';

const alertContext = createContext();

export default alertContext;



// WEBPACK FOOTER //
// ./src/context/alert/alertContext.js